export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: '__slot:links_target_name',
        sortField: 'name',
        type: 'string',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: '__slot:links_target_url',
        sortField: 'url',
        type: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'dr',
        sortField: 'dr',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:links_source_url',
        sortField: 'source_url',
        type: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:links_anchor',
        sortField: 'anchor',
        type: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'link_type',
        sortField: 'link_type',
        type: 'link_type',
        callback: 'linkType',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'rel_type',
        sortField: 'rel_type',
        type: 'rel_type',
        callback: 'linkRelType',
        defaultValue: () => [],
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'created_at',
        sortField: 'created_at',
        type: 'dateRange',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'updated_at',
        sortField: 'updated_at',
        type: 'dateRange',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'status',
        sortField: 'status',
        callback: 'linkStatus',
        type: 'link_status',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        // Только в фильтре: путь страницы сайта, на которой стоят ссылки (сюда ведут ссылки из пакетного анализа
        // по ссылкам в режиме URL). Корень — /
        name: 'source_path',
        type: 'string',
        visible: false,
        defaultSearch: false,
        useInFilter: true,
    }
]
